import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'transparent', 'current',
        'brand-primary', 'brand-hover', 'brand-tint', 'brand-on-primary',
        'surface-canvas', 'surface-default', 'surface-subtle', 'surface-overlay',
        'border-subtle', 'border-control', 'border-control-strong',
        'text-primary', 'text-secondary', 'text-muted',
        'success', 'success-bg', 'warning', 'warning-bg', 'danger', 'danger-bg', 'info', 'info-bg',
        'focus',
        'chart-1', 'chart-2', 'chart-3', 'chart-4', 'chart-5', 'chart-previous',
      ],
    },
    classGroups: {
      'font-size': [{ text: ['helper', 'body', 'card-title', 'heading', 'kpi'] }],
      rounded: [{ rounded: ['control', 'menu', 'card', 'dialog', 'pill'] }],
      shadow: [{ shadow: ['card', 'overlay'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
